import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import {
  environment
} from 'src/environments/environment';
import { DivisionInfo } from '../model/division.model';
import { DepartmentInfo } from '../model/department.model';
import { SectionInfo } from '../model/SectionInfo.model';
import { UnitInfo } from '../model/UnitInfo.model';
import { PositionLevelInfo } from '../model/PositionManagementInfo.model';
import { JobInfo } from '../model/Job.model';
import { LaborRateInfo } from '../model/LaborRate.model';

@Component({
  selector: 'app-sale-labor-rate-master',
  templateUrl: './sale-labor-rate-master.component.html',
  styleUrls: ['./sale-labor-rate-master.component.css']
})
export class SaleLaborRateMasterComponent implements OnInit {

  baseurl: string;
  _EmpCode: string;  

  //search
  searchEffectiveFrom: string = "";
  searchEffectiveTo: string = "";
  searchDivision: string = "";
  searchDepartment: string = "";
  searchSection: string = "";
  searchUnit: string = "";
  searchJobTitle: string = "";
  searchPosition: number = 0;
  checkboxStatusActive: boolean = true;
  checkboxStatusInactive: boolean = true;

  isSearchSubmitted: boolean = false;
  
  DivisionList: DivisionInfo[] = [];
  DepartmentList: DepartmentInfo[] = [];
  SectionList: SectionInfo[] = [];
  UnitList: UnitInfo[] = [];
  JobList: JobInfo[] = [];
  PositionList: PositionLevelInfo[] = [];

  //primary data
  modelList: LaborRateInfo[] = [];

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number
  public countModel: number
  public totalPages: number
  public environment: number
  public pagesize: number = 10;

  //functionality
  element: HTMLElement;

  //modal
  modalMode: string = "CREATE";
  modalDataId: number;

  modalEffectiveFrom: string = "";
  modalEffectiveTo: string = "";
  modalDivision: string = "";
  modalDepartment: string = "";
  modalSection: string = "";
  modalUnit: string = "";
  modalJobTitle: string = "";
  modalPosition: number = 0;
  modalCost: string = "";
  modalPrice: string = "";
  modalStatus: string = "";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    this._EmpCode = window.localStorage.getItem('EmpCode');

    GlobalService.CheckPagingAccessRights();

  }

  ngOnInit() {
    this.resetSearch();
    this.currentPageNumber = 1;

    this.LoadSearchLookup();
    this.LoadData();
  }

  //misc

  validateModalSubmit() {

    if (this.modalEffectiveFrom == null || this.modalEffectiveFrom == "") {
      alert("Please select effective from date")
      return false;
    }

    if (this.modalEffectiveTo == null || this.modalEffectiveTo == "") {
      alert("Please select effective to date")
      return false;
    }

    //if (this.modalDivision == null || this.modalDivision == "") {
    //  alert("Please select division")
    //  return false;
    //}

    //if (this.modalDepartment == null || this.modalDepartment == "") {
    //  alert("Please select department")
    //  return false;
    //}

    //if (this.modalSection == null || this.modalSection == "") {
    //  alert("Please select section")
    //  return false;
    //}

    //if (this.modalUnit == null || this.modalUnit == "") {
    //  alert("Please select unit")
    //  return false;
    //}

    //was Job, changed to Position
    if (this.modalJobTitle == null || this.modalJobTitle == "") {
      alert("Please select position")
      return false;
    }

    //if (this.modalPosition == null || this.modalPosition == 0) {
    //  alert("Please select position")
    //  return false;
    //}

    if (this.modalCost == null || this.modalCost == "") {
      alert("Please select cost")
      return false;
    }

    if (this.modalPrice == null || this.modalPrice == "") {
      alert("Please select price")
      return false;
    }

    if (this.modalStatus == null || this.modalStatus == "") {
      alert("Please select status")
      return false;
    }

    return true;
  }

  removeCommasPrice() {
    let result = this.modalPrice.replace(/,/g, '');
    this.modalPrice = result;
  }

  replaceCommasPrice() {
    if (Number(this.modalPrice) < 0 || !this.modalPrice) this.modalPrice = "0.00";

    let result = this.modalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    if (result.indexOf('.') < 0) {
      result += ".00";
    }

    this.modalPrice = result;
  }


  removeCommasCost() {
    let result = this.modalCost.replace(/,/g, '');
    this.modalCost = result;
  }

  replaceCommasCost() {
    if (Number(this.modalCost) < 0 || !this.modalCost) this.modalCost = "0.00";

    let result = this.modalCost.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    if (result.indexOf('.') < 0) {
      result += ".00";
    }

    this.modalCost = result;
  }


  validateModalDateFrom() {
    if (this.modalEffectiveTo && this.modalEffectiveFrom > this.modalEffectiveTo) {
      this.modalEffectiveFrom = "";
      alert("Cannot select start period later than end period.")
    }
  }
  validateModalDateTo() {
    if (this.modalEffectiveFrom && this.modalEffectiveFrom > this.modalEffectiveTo) {
      this.modalEffectiveTo = "";
      alert("Cannot select end period ealier than start period.")
    }
  }


  validateDateFrom() {
    if (this.searchEffectiveTo && this.searchEffectiveFrom > this.searchEffectiveTo) {
      this.searchEffectiveFrom = "";
      alert("Cannot select start period later than end period.")
    }
  }
  validateDateTo() {
    if (this.searchEffectiveFrom && this.searchEffectiveFrom > this.searchEffectiveTo) {
      this.searchEffectiveTo = "";
      alert("Cannot select end period ealier than start period.")
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  formatDate(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    } else {
      return null
    }

  }

  resetSearch() {
    this.searchEffectiveFrom = "";
    this.searchEffectiveTo = "";
    this.searchDivision = "";
    this.searchDepartment = "";
    this.searchSection = "";
    this.searchUnit = "";
    this.searchJobTitle = "";
    this.searchPosition = 0;
    this.checkboxStatusActive = true;
    this.checkboxStatusInactive = true;

    this.indexNo = 0;
    this.currentPageNumber = 1;

    this.isSearchSubmitted = false;
  }

  resetModal() {
    this.modalDataId = 0;
    this.modalEffectiveFrom = "";
    this.modalEffectiveTo = "";
    this.modalDivision = "";
    this.modalDepartment = "";
    this.modalSection = "";
    this.modalUnit = "";
    this.modalJobTitle = "";
    this.modalPosition = 0;
    this.modalCost = "";
    this.modalPrice = "";
    this.modalStatus = "";
  }

  LoadSearchLookup() {
    this.LoadDivision().then((data) => {
      this.DivisionList = data;
    });
    this.LoadDepartment().then((data) => {
      this.DepartmentList = data;
    });
    this.LoadSection().then((data) => {
      this.SectionList = data;
    });
    this.LoadUnit().then((data) => {
      this.UnitList = data;
    });
    this.LoadJob().then((data) => {
      this.JobList = data;
    });
    this.LoadPosition().then((data) => {
      this.PositionList = data;
    });
  }

  //on Event
  btnClick_searchItem() {
    this.isSearchSubmitted = true;
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadData()
  }

  btnClick_clearSearchItem() {
    this.resetSearch()
    this.LoadData()
  } 

  btnClick_submitModal() {
    if (!this.validateModalSubmit()) return;

    if (!confirm("Do you want to submit this change?")) return;

    this.CreateOrUpdateLaborRate();

    $('#modalLaborRate').modal('hide')
  }

  btnClick_cancelModal() {

    if (!confirm("Do you want to cancel this change?")) return;

    this.resetModal();
    $('#modalLaborRate').modal('hide')
  }

  btnClick_createItem() {
    this.resetModal();
    this.modalMode = "CREATE";
    $('#modalLaborRate').modal('show'); 
  }

  btnClick_editItem(id) {
    this.resetModal();
    this.modalDataId = id;
    this.modalMode = "EDIT";

    var curRec = this.modelList.find(x => { return x.id == this.modalDataId });

    console.log(curRec)

    this.modalEffectiveFrom = this.formatDate(curRec.EffectiveFrom);
    this.modalEffectiveTo = this.formatDate(curRec.EffectiveTo);
    this.modalDivision = curRec.DivisionCode;
    this.modalDepartment = curRec.DepartmentCode;
    this.modalSection = curRec.SectionCode;
    this.modalUnit = curRec.UnitCode;
    this.modalJobTitle = curRec.JobTitleCode;
    this.modalPosition = curRec.PositionCode;
    this.modalCost = curRec.CostRate.toString();
    this.modalPrice = curRec.PriceRate.toString();
    this.modalStatus = curRec.StatusCode;

    this.replaceCommasCost()
    this.replaceCommasPrice()

    $('#modalLaborRate').modal('show'); 
  }

  async btnClick_deleteItem(id) {

    let idlist = [];

    if (confirm("Are you sure to delete this record?")) {

      var curRec = this.modelList.find(x => { return x.id == id });

      idlist.push(curRec)

      this.DeleteList(idlist);
    }
  }

  async btnClick_deleteItemList() {
    var checkedLaborRate = $('[name="checkboxLaborRate"]:checked');

    let num = checkedLaborRate.length;
    let idlist = [];

    if (num <= 0) return;

    if (confirm("Are you sure to delete this record?" + "\n The labor rate to remove " + num + " record(s).")) {

      for (var i = 0; i < num; i++) {

        var current = <HTMLInputElement>checkedLaborRate[i];

        var curRec = this.modelList.find(x => { return x.id == parseInt(current.value) });

        idlist.push(curRec)
      }

      this.DeleteList(idlist);
    }
  }


  //load data/ resquest

  async CreateOrUpdateLaborRate() {
    if (true) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        this.removeCommasCost()
        this.removeCommasPrice()

        var objectjson = {};
        if (this.modalDataId != null && this.modalDataId != 0) {
          objectjson['id'] = this.modalDataId;
          objectjson['UpdateBy'] = this._EmpCode;
        } else {
          objectjson['CreateBy'] = this._EmpCode;
        }

          
        objectjson['EffectiveFrom'] = this.modalEffectiveFrom;
        objectjson['EffectiveTo'] = this.modalEffectiveTo;
        objectjson['DivisionCode'] = this.modalDivision;
        objectjson['DepartmentCode'] = this.modalDepartment;
        objectjson['SectionCode'] = this.modalSection;
        objectjson['UnitCode'] = this.modalUnit;
        objectjson['JobTitleCode'] = this.modalJobTitle;
        objectjson['PositionCode'] = this.modalPosition;
        objectjson['CostRate'] = Number(this.modalCost);
        objectjson['PriceRate'] = Number(this.modalPrice);
        objectjson['StatusCode'] = this.modalStatus;

        let strjson = JSON.stringify(objectjson);

        let isSubmitted = this.httpClient.post<LaborRateInfo[]>(this.baseurl + "LaborRate/CreateOrUpdateLaborRate", strjson, httpOptions)

          .subscribe(result => isSubmitted = result, failCb => {
            console.log("Create/Update fail");
          },
            async () => {
              console.log("Create/Update = " + isSubmitted);

              if (this.modalDataId != 0) {
                $('#ModalUpdateComplate').modal();
              } else {
                $('#ModalCreateComplate').modal();
              }

              this.resetSearch();
              this.resetModal();
              this.LoadData();
            }
          )
      }

    }

  }

  async DeleteList(idlist: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      let strjsonCusInfo = JSON.stringify(idlist);

      return this.httpClient.post<LaborRateInfo[]>(this.baseurl + "LaborRate/DeleteListLaborRate", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          async data => {
            alert("Deletion completed.")

            this.resetSearch()
            this.LoadData()

          }
        );
    }
  }

  LoadData() {
    this.getLaborRate()
      .then(
        data => {
          this.modelList = data;

          this.countModel = (this.modelList.length != 0) ? data[0].rowTotal : 0;
        }
      ).then(() => {
        if (this.countModel == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.countModel / environment.PageSize)
      })
  }

  async getLaborRate() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {};

      objectjson['EffectiveFrom'] = this.searchEffectiveFrom;
      objectjson['EffectiveTo'] = this.searchEffectiveTo;
      objectjson['DivisionCode'] = this.searchDivision;
      objectjson['DepartmentCode'] = this.searchDepartment;
      objectjson['SectionCode'] = this.searchSection;
      objectjson['UnitCode'] = this.searchUnit;
      objectjson['JobTitleCode'] = this.searchJobTitle;
      objectjson['PositionCode'] = this.searchPosition;
      objectjson['StatusCode'] = this.checkboxStatusActive && this.checkboxStatusInactive ? null : !this.checkboxStatusActive && !this.checkboxStatusInactive ? 'NONE' : this.checkboxStatusActive ? 'ACTIVE' : 'INACTIVE';
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient
        .post<LaborRateInfo[]>(this.baseurl + "LaborRate/GetLaborRate",
          strjson, httpOptions)
        .toPromise();
    }
  }

  async LoadDivision() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/GetDivision", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadDepartment() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<DepartmentInfo[]>(this.baseurl + "Department/GetDepartment", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadSection() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<SectionInfo[]>(this.baseurl + "Section/GetSection", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadUnit() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<UnitInfo[]>(this.baseurl + "Unit/GetUnit", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadJob() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise()
    }
  }

  //pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
}
